import React from 'react';
import { MenuItem, ListItemIcon, ListItemText, Divider, useTheme } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { useTopNavCreateActions } from '@/components/buttons/TopNavCreateActions';
import { addMenuList } from './addMenuItems';

export const MobileMenu = () => {
	const theme = useTheme();
	const { menuItems: createMenuList } = useTopNavCreateActions();

	return (
		<>
			<Divider />
			{createMenuList.map((item, index) => (
				<MenuItem key={`${index}-${item.text}`} onClick={item.onClick}>
					<ListItemIcon>{item.icon}</ListItemIcon>
					<ListItemText primary={item.text} />
				</MenuItem>
			))}
			<Divider />
			{addMenuList.map((item, index) => (
				<MenuItem key={`${index}-${item.text}`} component={NavLink} to={item.link}>
					<ListItemIcon>
						<item.Icon
							width='25px'
							height='25px'
							bgColor='transparent'
							color={theme.palette.primary.main}
						/>
					</ListItemIcon>
					<ListItemText primary={item.text} />
				</MenuItem>
			))}
			<Divider />
		</>
	);
};
